export const TRUST_BAR_LOGOS = [
  { src: '/img/users/netapp.svg', alt: 'NetApp' },
  { src: '/img/users/samsung.svg', alt: 'Samsung' },
  { src: '/img/users/comcast.svg', alt: 'Comcast' },
  { src: '/img/users/salesforce.svg', alt: 'Salesforce' },
  { src: '/svgs/icons/sarvam.svg', alt: 'Sarvam AI' },
  { src: '/svgs/icons/blaxel.svg', alt: 'Blaxel' },
]
